import { useEffect } from "react";

function clamp(text, budget = 45) {
  const t = String(text || "").replace(/\s+/g, " ").trim();
  if (t.length <= budget) return t;
  const cut = t.slice(0, budget - 1);
  const sep = Math.max(cut.lastIndexOf(" "), cut.lastIndexOf("—"), cut.lastIndexOf("·"));
  return `${(sep > budget * 0.5 ? cut.slice(0, sep) : cut).replace(/[\s—·]+$/, "")}…`;
}

/* Client-side SEO: title + meta description per page, plus <link rel=canonical> on the
   page's own clean public URL — the same URL the Worker serves the rendered HTML on,
   for every visitor, and the one listed in the sitemap. */
export function useSeo(title, description, canonicalPath) {
  useEffect(() => {
    // Brand last, and never a bare brand title: the discriminating value comes first.
    // A title that already carries the brand (home) is used verbatim; everywhere else the
    // discriminating value comes first and the brand is appended.
    if (title) document.title = title.startsWith("Rookie Radar") ? title : `${clamp(title)} · Rookie Radar`;
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);
    }
    let link = document.querySelector('link[rel="canonical"]');
    if (canonicalPath) {
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", `${window.location.origin}${window.location.pathname}`);
    } else if (link) {
      link.remove();
    }
  }, [title, description, canonicalPath]);
}
